import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { logUsage } from 'owa-analytics';
import { lazyBootstrapYammer } from 'owa-yammer-bootstrap';
import { lazyOpenYammerPublisher } from 'owa-yammer-publisher';

export default function initializeYammerPublisher(): void {
    // Prefetch and bootstrap yammer
    lazyBootstrapYammer.import().then(bootstrapYammer => bootstrapYammer());
    logUsage('YammerPublisher_PrefetchHit', getGlobalSettingsAccountMailboxInfo());

    // Prefetch main dialog code
    lazyOpenYammerPublisher.import();
}
